import { GOLD_DATA } from '../../common/types';
import { Table } from '../../../Molecules/table';
import { Chevron } from '../../../Atoms/Chevron/Chevron';
import { CITY_COMPARISON_COLUMNS } from './CityComparison_columns';
import { useCityComparison } from './useCityComparison';

interface CityComparisonTableProps {
  citiesData: GOLD_DATA[];
  metroCities: string[];
  city: string;
}

export const CityComparisonTable = ({
  citiesData,
  metroCities,
  city,
}: CityComparisonTableProps): JSX.Element | null => {
  const { displayData, hasMore, handleViewMore, isEmpty } = useCityComparison({
    citiesData,
    metroCities,
    city,
  });

  if (isEmpty) return null;

  return (
    <div>
      <Table
        columns={CITY_COMPARISON_COLUMNS}
        tableId="cityComparisonTable"
        data={displayData}
        viewMoreToggle={false}
        stickyFirstColumn={true}
      />
      {hasMore && (
        <button
          onClick={handleViewMore}
          className="w-full py-3 font-semibold text-base text-blue-350 flex items-center justify-center outline-none focus:outline-none"
        >
          View More
          <Chevron direction="down" className="mt-1 ml-5" thickness={10} />
        </button>
      )}
    </div>
  );
};
